import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import { store } from '../../../../store/store';
import AclContextProvider from '../../../Acl/Components/AclContextProvider';
import RootWorkplaceSettingsButton from './RootWorkplaceSettingsButton';

loadDOMComponent({
	selector: 'react-root-workplace-settings',
	callback: ({ container, context, props }: any) => {
		const rootWorkplaceId = container.getAttribute('rootWorkplaceId');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<RootWorkplaceSettingsButton rootWorkplaceId={rootWorkplaceId} />
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
